import * as t from 'io-ts';
import { SharingDataDynamicType } from './sharingData';

export const SharingDataListDynamicType = t.interface({
    shared: t.array(SharingDataDynamicType),
    previousEmails: t.array(t.string)
});

export type SharingDataList = t.TypeOf<typeof SharingDataListDynamicType>;
